import React from 'react'
import { Trans } from '@lingui/react/macro'
import { useLingui } from '@lingui/react/macro'
import { XStack, YStack } from 'tamagui'

import { Card } from '@newComponents/Card'
import { Icon } from '@newComponents/Icon'
import { Paragraph } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { DocSection } from '../shared/DocSection'

const AttendeeForms = () => {
  const { t } = useLingui()

  return (
    <>
      <Card gap='$4'>
        <Paragraph size='$5'>
          <Trans>
            Attendee forms let organizers collect additional information from
            people when they RSVP or purchase tickets. This is useful for
            gathering details like dietary requirements, t-shirt sizes,
            accessibility needs, company names, or any other information that
            helps you plan a better Event.
          </Trans>
        </Paragraph>
        {/* TODO: Capture screenshot of Event Settings → Attendees showing Event Registration Form selection */}
      </Card>

      <Card gap='$4'>
        <DocSection id='form-management' title={t`Form Management`}>
          <YStack gap='$3'>
            <XStack gap='$3' alignItems='flex-start'>
              <Icon
                name='settings'
                size='$5'
                color='$color'
                flexShrink={0}
                marginTop={2}
              />
              <Paragraph size='$5'>
                <Trans>
                  <Paragraph size='$5' fontWeight='$7'>
                    Setting up forms
                  </Paragraph>{' '}
                  — Open{' '}
                  <Link href='/docs/events/settings'>Event Settings</Link> and
                  go to the Attendees section. Use the Event Registration Form
                  area to select an existing form or create a new one. Forms can
                  include custom fields with labels and input types, and each
                  field can be marked as required or optional.
                </Trans>
              </Paragraph>
            </XStack>
            <XStack gap='$3' alignItems='flex-start'>
              <Icon
                name='person'
                size='$5'
                color='$color'
                flexShrink={0}
                marginTop={2}
              />
              <Paragraph size='$5'>
                <Trans>
                  <Paragraph size='$5' fontWeight='$7'>
                    Attendee experience
                  </Paragraph>{' '}
                  — When attendees RSVP or go through the{' '}
                  <Link href='/docs/events/purchase-flow'>
                    ticket purchase flow
                  </Link>
                  , they see the custom form fields alongside the standard
                  registration fields. The form is presented inline, so
                  attendees complete everything in a single step.
                </Trans>
              </Paragraph>
            </XStack>
            <XStack gap='$3' alignItems='flex-start'>
              <Icon
                name='search'
                size='$5'
                color='$color'
                flexShrink={0}
                marginTop={2}
              />
              <Paragraph size='$5'>
                <Trans>
                  <Paragraph size='$5' fontWeight='$7'>
                    Viewing responses
                  </Paragraph>{' '}
                  — Organizers can use the attendee tools in Event Settings to
                  review registrations, pending approvals, and attendee exports
                  for offline planning.
                </Trans>
              </Paragraph>
            </XStack>
          </YStack>
        </DocSection>
      </Card>

      <Card gap='$4'>
        <DocSection id='form-updates' title={t`Updating Forms`}>
          <Paragraph size='$5'>
            <Trans>
              Forms can be added or updated at any time, even after attendees
              have already RSVPed. Existing attendees are not required to fill
              out newly added fields, but new attendees will see them during
              registration.
            </Trans>
          </Paragraph>
        </DocSection>
      </Card>
    </>
  )
}

export default AttendeeForms
